import React from 'react'
import { Modal } from 'react-bootstrap'
import UserActivityLog from './UserActivityLog'

interface UserActivityLogModalProps {
  show: boolean
  header: string
  selectedUserId: number
  userName: string
  userCode?: string
  onHide: () => void
}

const UserActivityLogModal: React.FC<UserActivityLogModalProps> = ({
  show,
  header,
  selectedUserId,
  userName,
  userCode,
  onHide,
}) => {
  return (
    <Modal
      size="lg"
      backdrop="static"
      show={show}
      onHide={onHide}
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          {`${header}: ${userName}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UserActivityLog selectedUserId={selectedUserId} userCode={userCode} />
      </Modal.Body>
    </Modal>
  )
}

export default UserActivityLogModal
